import React from "react";
import { RaceStatus, RaceStatusEnum, RaceVideo } from "@tvg/ts-types/Race";
import { TvBrand } from "../../../TvBrand";
import { Icon } from "../../../Icon";

export const renderIcon = (video: RaceVideo, status: RaceStatus) => {
  if (status.code === RaceStatusEnum.RACE_OFFICIAL) {
    return (
      <Icon
        name={video?.hasReplay ? "replay" : "noVideo"}
        size="s"
        lineColor="content.subtle"
      />
    );
  }

  const isLiveTvAvailable = video?.onTvg || video?.onTvg2; // TODO: Add condition for FDRTV when logo is available
  return isLiveTvAvailable ? <TvBrand height={16} brandColor="grey" /> : null;
};
